import React from 'react';

/**
 * Thin line icons for the Client Details section headers — exact glyphs from
 * the mockup (currentColor stroke), sized to sit in the 28px header chip.
 */
type GlyphProps = { size?: number };

/** Bio — person. */
export const UserGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <circle cx="7" cy="5" r="2.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M2 12c0-2.2 2.2-4 5-4s5 1.8 5 4" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

/** Incomes — clock. */
export const ClockGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path
      d="M7 1.5v4l2.5 1.5M2.5 7a4.5 4.5 0 1 0 9 0 4.5 4.5 0 0 0-9 0z"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

/** Accounts — clipboard / statement. */
export const ClipboardGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <rect x="2" y="1.5" width="10" height="11" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path d="M4.5 5h5M4.5 7.5h5M4.5 10h3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

/** Chevron caret used as the accordion expand indicator (MUI rotates it). */
export const CaretGlyph: React.FC<GlyphProps> = ({ size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M4 5.5L7 8.5L10 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Folded document — Financial Plan tab. */
export const DocGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M3 1.5H8L11 4.5V12.5H3V1.5Z M8 1.5V4.5H11" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
  </svg>
);

/** Activity pulse — Plan Engagement tab. */
export const PulseGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M1 7H3.5L5 3L7.5 11L9 7H13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Clock-with-arrow — History tab. */
export const HistoryGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M2 7a5 5 0 1 0 1.5-3.5M2 3.5V7h3.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/** Pencil — "Edit client" menu action. */
export const EditGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M9 2.5L11.5 5L5 11.5H2.5V9L9 2.5Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" />
  </svg>
);

/** Plus — "New plan request" menu action. */
export const PlusGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path d="M7 2.5V11.5M2.5 7H11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

/** Trash — "Remove from dashboard" menu action. */
export const TrashGlyph: React.FC<GlyphProps> = ({ size = 15 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <path
      d="M2.5 3.5h9M5 3.5V2.5h4v1M4 3.5l0.55 9h4.9l0.55-9"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Padlock — locked workspace-tab marker (shortfall gating). */
export const LockGlyph: React.FC<GlyphProps> = ({ size = 11 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" aria-hidden>
    <rect x="2.5" y="6" width="9" height="6.5" rx="1.5" stroke="currentColor" strokeWidth="1.3" />
    <path
      d="M4.5 6V4.5a2.5 2.5 0 0 1 5 0V6"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);
